import { render, staticRenderFns } from "./IconTwitter.vue?vue&type=template&id=66cf139d"
import script from "./IconTwitter.vue?vue&type=script&lang=js"
export * from "./IconTwitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports